import { render, staticRenderFns } from "./HorizontalCollectionListSkeletonLoader.vue?vue&type=template&id=53931d69&"
import script from "./HorizontalCollectionListSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./HorizontalCollectionListSkeletonLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports